// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as $$String from "../../../../../../node_modules/rescript/lib/es6/string.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_string from "../../../../../../node_modules/rescript/lib/es6/js_string.js";
import * as Caml_array from "../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as UrlUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.mjs";
import * as MediaQuery$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/hooks/MediaQuery.mjs";
import * as MoEngage$PorterinFeature from "../../../containers/fare-estimate-v1/utils/moengage/MoEngage.mjs";
import * as GaPublisher$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/react-ga/publishers/GaPublisher.mjs";
import * as CookieHelpers$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/helpers/CookieHelpers.mjs";
import * as CookieStore$PorterinFeature from "../../../containers/fare-estimate-v1/utils/browser/CookieStore.mjs";
import * as CookieUtils$PorterinFeature from "../../../containers/fare-estimate-v1/utils/browser/CookieUtils.mjs";
import * as CookieConstants$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/constants/CookieConstants.mjs";
import * as AppConfigHelpers$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/helpers/AppConfigHelpers.mjs";
import * as MoEngageHelper$PorterinFeature from "../../../containers/fare-estimate-v1/utils/moengage/MoEngageHelper.mjs";
import * as AnalyticsHelper$PorterinFeature from "./AnalyticsHelper.mjs";

function getVisitorId(param) {
  var visitorId = CookieHelpers$PorterinUtils.getCookie(CookieStore$PorterinFeature.visitorId);
  if (visitorId === "") {
    return "";
  } else {
    return visitorId;
  }
}

function getGa4ClientId(param) {
  var gaCookie = CookieHelpers$PorterinUtils.getCookie(CookieConstants$PorterinUtils.ga_cookie);
  if (gaCookie === "") {
    return "";
  }
  var parts = Js_string.split(".", gaCookie);
  var length = parts.length;
  if (length >= 4) {
    return Caml_array.get(parts, 2) + "." + Caml_array.get(parts, 3);
  } else {
    return "";
  }
}

function getUtmParams(param) {
  var url = window.location.href;
  var urlParams = UrlUtils$Catalyst.getURLParams(UrlUtils$Catalyst.getSearchParams(url));
  return {
          campaign_id: Belt_Option.getWithDefault(Js_dict.get(urlParams, "utm_id"), ""),
          campaign: Belt_Option.getWithDefault(Js_dict.get(urlParams, "utm_campaign"), ""),
          source: Belt_Option.getWithDefault(Js_dict.get(urlParams, "utm_source"), ""),
          medium: Belt_Option.getWithDefault(Js_dict.get(urlParams, "utm_medium"), ""),
          term: Belt_Option.getWithDefault(Js_dict.get(urlParams, "utm_term"), ""),
          content: Belt_Option.getWithDefault(Js_dict.get(urlParams, "utm_content"), "")
        };
}

function getGaEventPayload(payload) {
  var locale = CookieHelpers$PorterinUtils.getCookie(CookieConstants$PorterinUtils.next_locale);
  return {
          hitType: "event",
          eventCategory: payload.category,
          eventAction: payload.action,
          eventLabel: payload.label,
          eventValue: payload.value,
          nonInteraction: payload.nonInteraction,
          send_to: AppConfigHelpers$PorterinUtils.getGaTrackingIdByLocale(locale)
        };
}

function publishEventGA(payload) {
  GaPublisher$PorterinUtils.publishGaEvent(getGaEventPayload(payload));
}

function addCommonMoEngageAttrs(payload) {
  var ga4ClientId = getGa4ClientId(undefined);
  var visitorId = getVisitorId(undefined);
  var utmParams = getUtmParams(undefined);
  return Object.assign(payload, {
              backend_service: "platform",
              device_type: matchMedia(MediaQuery$PorterinUtils.minWidthDesktop).matches ? "desktop" : "mobile",
              client_id: ga4ClientId,
              campaign_id: utmParams.campaign_id,
              campaign: utmParams.campaign,
              source: utmParams.source,
              medium: utmParams.medium,
              term: utmParams.term,
              content: utmParams.content,
              session_id: visitorId
            });
}

function isMoengageEnabled(param) {
  var config = AnalyticsHelper$PorterinFeature.getMoEngageConfigByLocale(CookieUtils$PorterinFeature.getCookie(CookieConstants$PorterinUtils.next_locale));
  if (config !== undefined && config.moengage_enable_flag) {
    return true;
  } else {
    return false;
  }
}

function publishEventMoEngage(payload) {
  var moEngagePayload = MoEngageHelper$PorterinFeature.getTrackEventPayload(payload);
  var updatedMoengagePayload = addCommonMoEngageAttrs(moEngagePayload);
  var match = MoEngage$PorterinFeature.isMoengageObjPresent(undefined) && MoEngageHelper$PorterinFeature.shouldFireMoeEvent(payload.action) && isMoengageEnabled(undefined);
  if (match) {
    Moengage.track_event(payload.action, updatedMoengagePayload);
    return ;
  }
  
}

function publishEvent(payload) {
  publishEventMoEngage(payload);
  GaPublisher$PorterinUtils.publishGaEvent(getGaEventPayload(payload));
}

function getNumberedEventLabel(labels) {
  var modified_labels = List.mapi((function (index, label) {
          return String(index + 1 | 0) + ("_" + label);
        }), labels);
  return $$String.concat("#", modified_labels);
}

function publishEventParameter(event_name, payload) {
  var updatedMoengagePayload = addCommonMoEngageAttrs(payload);
  if (MoEngage$PorterinFeature.isMoengageObjPresent(undefined) && MoEngageHelper$PorterinFeature.shouldFireMoeEvent(event_name) && isMoengageEnabled(undefined)) {
    Moengage.track_event(event_name, updatedMoengagePayload);
  }
  GaPublisher$PorterinUtils.publishGaEventParameter(event_name, payload);
}

function publishMoengageEventParameter(event_name, payload) {
  var updatedMoengagePayload = addCommonMoEngageAttrs(payload);
  var isMoePresent = MoEngage$PorterinFeature.isMoengageObjPresent(undefined);
  var shouldFire = MoEngageHelper$PorterinFeature.shouldFireMoeEvent(event_name);
  var isEnabled = isMoengageEnabled(undefined);
  if (isMoePresent && shouldFire && isEnabled) {
    Moengage.track_event(event_name, updatedMoengagePayload);
    return ;
  }
  
}

export {
  getVisitorId ,
  getGa4ClientId ,
  getUtmParams ,
  getGaEventPayload ,
  publishEventGA ,
  addCommonMoEngageAttrs ,
  isMoengageEnabled ,
  publishEventMoEngage ,
  publishEvent ,
  getNumberedEventLabel ,
  publishEventParameter ,
  publishMoengageEventParameter ,
}
/* MediaQuery-PorterinUtils Not a pure module */
